import { useSyncExternalStore } from 'react';

export type ScreenSize = 'small' | 'medium' | 'large';
type ScreenSizeSubscriber = () => void;

function createScreenSizeStore() {
  const subscribers = new Set<ScreenSizeSubscriber>();
  let screenSize: ScreenSize = 'small';

  if (typeof window !== 'undefined') {
    const smallMQL = window.matchMedia('(max-width: 768px)');
    const mediumMQL = window.matchMedia(
      '(min-width: 769px) and (max-width: 1024px)',
    );
    const largeMQL = window.matchMedia('(min-width: 1025px)');

    if (mediumMQL.matches) {
      screenSize = 'medium';
    } else if (largeMQL.matches) {
      screenSize = 'large';
    }

    function createHandler(size: ScreenSize) {
      return function updateScreenSize(event: MediaQueryListEvent) {
        if (!event.matches) return;
        screenSize = size;
        subscribers.forEach((subscriber) => subscriber());
      };
    }

    smallMQL.addEventListener('change', createHandler('small'));
    mediumMQL.addEventListener('change', createHandler('medium'));
    largeMQL.addEventListener('change', createHandler('large'));
  }

  return {
    subscribe: (cb: ScreenSizeSubscriber) => {
      subscribers.add(cb);
      return () => {
        subscribers.delete(cb);
      };
    },
    getScreenSize: () => {
      return screenSize;
    },
  };
}

const screenSizeStore = createScreenSizeStore();

export function useScreenSize() {
  return useSyncExternalStore(
    screenSizeStore.subscribe,
    screenSizeStore.getScreenSize,
    screenSizeStore.getScreenSize,
  );
}
